<template>
  <div
    class="relative overflow-y-auto"
    :style="{ height: 'calc(100vh - 4.5rem - 8rem - 3.5rem)' }"
  >
    <div class="sticky top-0 z-10 py-4 px-6 flex gap-2 bg-pure-white">
      <div
        v-for="opt in filterOptions"
        :key="opt.value"
        class="px-2 h-7.5 flex-shrink-0 flex items-center rounded-full transition-all duration-300 cursor-pointer"
        :class="[
          opt.value === activeFilter ? 'bg-light-purple-400' : 'bg-slate-200'
        ]"
        @click="activeFilter = opt.value"
      >
        <BlTextBody2
          :text="opt.label"
          :class="[
            opt.value === activeFilter ? 'text-pure-white' : 'text-slate-800'
          ]"
        />
      </div>
    </div>
    <div v-if="fetchLoading" class="h-full grid items-center justify-center">
      <div class="blum-loader"></div>
    </div>
    <div
      v-else-if="!prospectInstructionHistories.length"
      class="h-full grid items-center justify-center"
    >
      <BlTextBody2
        text="There are no instruction histories for this prospect."
      />
    </div>
    <div v-else class="pb-4 px-6 flex flex-col gap-2">
      <InstructionProspect
        v-for="instruction in prospectInstructionHistories"
        :key="instruction.id"
        :instruction="instruction"
        @after-commit="fetchProspectInstructionHistories"
      />
      <!-- editable -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import InstructionProspect from "./InstructionProspect.vue";

import BlTextBody2 from "../../../BlTextBody2.vue";

export default {
  name: "InstructionHistoryTab",
  components: {
    InstructionProspect,
    BlTextBody2
  },
  props: {},
  data() {
    return {
      fetchLoading: false,
      activeFilter: "all", // todo | notes | documents
      filterOptions: [
        { value: "all", label: "All" },
        { value: "todo", label: "To-dos" },
        { value: "notes", label: "Notes" },
        { value: "documents", label: "Contain documents" }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "prospectStage",
      "prospectInstructionHistories"
    ])
  },
  watch: {
    activeFilter() {
      this.fetchLoading = true;
      this.fetchProspectInstructionHistories();
    }
  },
  mounted() {
    this.fetchLoading = true;
    this.fetchProspectInstructionHistories();
  },
  methods: {
    ...mapActions(["getProspectInstructionHistories"]),
    fetchProspectInstructionHistories() {
      const data = {
        id: this.prospectStage.prospect.id,
        params: ""
      };
      /*
        ?type=todo // todo or notes
        &with_documents=true // list instructions that have documents
      */
      if (this.activeFilter !== "all") {
        if (this.activeFilter === "documents") {
          data.params = "?with_documents=true";
        } else {
          data.params = `?type=${this.activeFilter}`;
        }
      }
      this.getProspectInstructionHistories(data).then(({ success }) => {
        this.fetchLoading = false;
        // if (!success) return;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/modal/prospectPanel/InstructionHistoryTab.vue